<template>
	<CCard>
		<CCardHeader> Historique des caisses </CCardHeader>
		<CCardBody>
			<CRow>
				<CCol sm="4">
					<vc-date-picker
						mode="date"
						timezone="UTC"
						:masks="{ input: 'DD/MM/YYYY' }"
						v-model="startDate">
						<template v-slot="{ inputValue, inputEvents }">
							<CInput
								label="Du"
								type="text"
								name="startDate"
								:value="inputValue"
								v-on="inputEvents" />
						</template>
					</vc-date-picker>
				</CCol>
				<CCol sm="4">
					<vc-date-picker
						mode="date"
						timezone="UTC"
						:masks="{ input: 'DD/MM/YYYY' }"
						v-model="endDate">
						<template v-slot="{ inputValue, inputEvents }">
							<CInput
								label="Au"
								type="text"
								name="endDate"
								:value="inputValue"
								v-on="inputEvents" />
						</template>
					</vc-date-picker>
				</CCol>

				<CCol col="4">
					<div class="form-group">
						<label>Poste</label>
						<GTreeView
							:multiple="false"
							v-on:update:selected="data => (user = data)"
							:default-options="true"
							:load-options="loadOptions"
							:async="true" />
					</div>
				</CCol>
				<CCol sm="12">
					<GLoadingButton :loading="loading" label="Télécharger" v-on:click="download" />
				</CCol>
			</CRow>
		</CCardBody>
	</CCard>
</template>

<script>
	import GLoadingButton from '../../../../components/ghostlexly-components/GLoadingButton';
	import GTreeView from '../../../../components/ghostlexly-components/GTreeView';
	export default {
		name: 'history',
		components: { GTreeView, GLoadingButton },
		data() {
			return {
				startDate: this.$moment().format('YYYY-MM-DD'),
				endDate: this.$moment().format('YYYY-MM-DD'),
				user: null,
				loading: false,
			};
		},

		methods: {
			download() {
				if (!this.user) {
					this.$toast.error('Veuillez choisir un poste !');
					return false;
				}
				if (!this.startDate || !this.endDate) {
					this.$toast.error('Veuillez sélectionner une date !');
					return false;
				}

				this.loading = true;
				let params = new URLSearchParams();
				params.append('createdAt[after]', this.$moment(this.startDate).format('YYYY-MM-DD'));
				params.append('createdAt[before]', this.$moment(this.endDate).format('YYYY-MM-DD'));
				params.append('method[]', 'payment.cash');
				params.append('method[]', 'payment.credit_card');
				params.append('method[]', 'payment.paypal');
				params.append('method[]', 'payment.check');
				params.append('method[]', 'payment.bank_transfer');
				params.append('method[]', 'payment.tpe');
				params.append('method[]', 'payment.credit_note');
				params.append('method[]', 'payment.dealer');
				params.append('itemsPerPage', '99999');

				if (this.user !== 'all') {
					params.append('createdBy', this.user);
				}

				// download the file
				this.$axios
					.get(`/api/payments/download/history`, { responseType: 'blob', params: params })
					.then(res => {
						if (res.status === 200 || res.status === 201) {
							let filename = res.headers['content-disposition'];
							filename = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(filename);
							if (filename != null && filename[1]) {
								filename = filename[1].replace(/['"]/g, '');
							} else {
								filename = 'file.pdf';
							}

							const url = window.URL.createObjectURL(new Blob([res.data]));
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', filename); //or any other extension
							document.body.appendChild(link);
							link.click();

							this.loading = false;
						}
					})
					.catch(err => {
						new Blob([err.response.data]).text().then(data => {
							data = JSON.parse(data);
							this.$toast.error(data['hydra:description']);
							this.loading = false;
						});
					});
			},

			loadOptions({ action, searchQuery, callback }) {
				if (action === 'ASYNC_SEARCH') {
					let params = new URLSearchParams();
					params.append('role', 'ROLE_ADMIN');
					params.append('email', searchQuery);

					this.$axios.get(`/api/users?${params.toString()}`).then(res => {
						let options = res.data['hydra:member'].map(item => {
							let label = item.email;

							return {
								'@id': item['@id'],
								name: label,
							};
						});

						options = [...options, { '@id': 'all', name: 'Toutes' }];

						callback(null, options);
					});
				}
			},
		},
	};
</script>
